<template>
  <div class="password-strength-container">
    <!-- 强度提示文本 -->
    <div class="strength-text">
      {{pwdStrengthLang.strength}}: <span :class="strengthClass">{{ strengthText }}</span>
    </div>
    <!-- 三段式进度条 -->
    <div class="strength-bar">
      <div
        class="bar-segment"
        :class="{ 'weak-active': strength >= 1, 'weak': strength < 1 }"
      ></div>
      <div
        class="bar-segment"
        :class="{ 'medium-active': strength >= 2, 'medium': strength < 2 }"
      ></div>
      <div
        class="bar-segment"
        :class="{ 'strong-active': strength >= 3, 'strong': strength < 3 }"
      ></div>
    </div>
    <!-- 验证规则提示 -->
    <div class="validation-hints">
      <p :class="{ 'valid': hasMinLength }">✓ {{pwdStrengthLang.hasMinLength}}</p>
      <p :class="{ 'valid': hasLetterAndNumber }">✓ {{pwdStrengthLang.hasLetterAndNumber}}</p>
      <p :class="{ 'valid': hasUpperAndLower }">✓ {{pwdStrengthLang.hasUpperAndLower}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    password:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      strength: 0, // 0-3 表示强度等级
    };
  },
  watch: {
    password(newVal,oldVal) {
      if(newVal!=oldVal){
        this.checkPasswordStrength()
      }
    }
  },
  computed: {
    pwdStrengthLang(){
      return {
            strength: "密碼強度",
            strong: "強",
            medium: "中",
            weak: "弱",
            hasMinLength: "長度6-20位",
            hasLetterAndNumber: "包含字母和數字",
            hasUpperAndLower: "包含大小寫字母"
      }
    },
    strengthText() {
      let Lang=this.pwdStrengthLang;
      switch (this.strength) {
        case 1: return Lang.weak;
        case 2: return Lang.medium;
        case 3: return Lang.strong;
        default: return Lang.weak;
      }
    },
    strengthClass() {
      switch (this.strength) {
        case 1: return 'weak-text';
        case 2: return 'medium-text';
        case 3: return 'strong-text';
        default: return '';
      }
    },
    hasMinLength() {
      return this.password.length >= 6 && this.password.length <= 20;
    },
    hasLetterAndNumber() {
      return /\d/.test(this.password) && /[a-zA-Z]/.test(this.password);
    },
    hasUpperAndLower() {
      return /[a-z]/.test(this.password) && /[A-Z]/.test(this.password);
    }
  },
  methods: {
    checkPasswordStrength() {
      const pwd = this.password;

      // 基础验证
      const hasMinLength = pwd.length >= 6 && pwd.length <= 20;
      const hasNumber = /\d/.test(pwd);
      const hasLetter = /[a-zA-Z]/.test(pwd);
      const hasLower = /[a-z]/.test(pwd);
      const hasUpper = /[A-Z]/.test(pwd);

      // 强度计算逻辑
      if (hasMinLength) {
        if(hasNumber && hasLower && hasUpper){
          if(pwd.length >= 8){
            this.strength = 3; // 强
          } else{
            this.strength = 2; // 中
          }

        } else if((hasNumber&&hasLower) || (hasNumber&&hasUpper)){
          this.strength = 1; // 中
        } else{
          this.strength = 0;
        }
      } else{
        this.strength = 0;
      }
    }
  }
};
</script>

<style scoped>
.password-strength-container {
  /* max-width: 300px; */
  margin: 0 auto;
  font-family: Arial, sans-serif;
  margin-bottom: 5px;
}

.strength-text {
  margin-bottom: 5px;
  font-size: 12px;
}

.weak-text {
  color: #ff4d4f;
  font-weight: bold;
}

.medium-text {
  color: #faad14;
  font-weight: bold;
}

.strong-text {
  color: #52c41a;
  font-weight: bold;
}

.strength-bar {
  display: flex;
  height: 3px;
  margin-bottom: 5px;
  gap: 2px;
}

.bar-segment {
  flex: 1;
  border-radius: 3px;
}

/* 默认状态 */
.weak {
  background-color: #ffccc7;
}

.medium {
  background-color: #ffccc7;
}

.strong {
  background-color: #ffccc7;
}

/* 激活状态 */
.weak-active {
  background-color: #ff4d4f;
}

.medium-active {
  background-color: #faad14;
}

.strong-active {
  background-color: #52c41a;
}

.validation-hints {
  font-size: 11px;
  color: #999;
  display: flex;
}

.validation-hints p {
  margin: 3px;
}

.validation-hints .valid {
  color: #52c41a;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordStrength.vue